import { render } from "./VisualizadorAnexo.vue?vue&type=template&id=39fd8160&scoped=true"
import script from "./VisualizadorAnexo.vue?vue&type=script&lang=js"
export * from "./VisualizadorAnexo.vue?vue&type=script&lang=js"

import "./VisualizadorAnexo.vue?vue&type=style&index=0&id=39fd8160&scoped=true&lang=css"
import "./VisualizadorAnexo.vue?vue&type=style&index=1&id=39fd8160&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39fd8160"]])

export default __exports__